module.exports = "/dog-racing/img/delete-purple.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/img/delete-purple.png
// module id = 1951
// module chunks = 7